var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2697",
    "data-name": "Group 2697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    d: "M9.672-.85A10.522,10.522,0,1,1-.85,9.672,10.534,10.534,0,0,1,9.672-.85Zm0,19.023a8.5,8.5,0,1,0-8.5-8.5A8.51,8.51,0,0,0,9.672,18.173Z",
    transform: "translate(0.85 0.85)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M20.561,21.571a1.007,1.007,0,0,1-.715-.3l-3.75-3.75A1.011,1.011,0,0,1,17.525,16.1l3.75,3.75a1.011,1.011,0,0,1-.715,1.725Z",
    transform: "translate(0.429 0.429)",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsearchIcon);
export default __webpack_public_path__ + "static/media/chatsearchIcon.ddee87bfc53dcd06a49db29b28dcf859.svg";
export { ForwardRef as ReactComponent };